import { Button, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useSingleUserControl } from "../../../context/SuperAdmin/SingleUserControlContext";
import DetachModal from "./DetachModal";
import AttachModal from "./AttachModal";
import AssignAdminModal from "./AssignAdminModal";
import UnassignAdminModal from "./UnassignAdminModal";

const AccountActions = () => {
  const [isDetachOpen, setIsDetachOpen] = useState(false);
  const [isAttachOpen, setIsAttachOpen] = useState(false);
  const [isAssignOpen, setIsAssignOpen] = useState(false);
  const [isUnassignOpen, setIsUnassignOpen] = useState(false);

  const [isAdminDominio, setIsAdminDominio] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { myOrgs, fetchOrgs, myRoles } = useSingleUserControl();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOption = (option: string) => {
    console.log("Opción seleccionada:", option);
    if (option === "Desanexar") {
      setIsDetachOpen(true);
    } else if (option === "Anexar") {
      fetchOrgs();
      setIsAttachOpen(true);
    } else if (option === "Asignar") {
      setIsAssignOpen(true);
    } else if (option === "Desasignar") {
      setIsUnassignOpen(true);
    }
    handleClose();
  };

  // Cada vez que cambien los roles, vamos a identificar si alguno es de Admin de Dominio
  useEffect(() => {
    const res = myRoles.find((rol) => rol.rol === "Admin de Dominio");
    if (res) {
      setIsAdminDominio(true);
    } else {
      setIsAdminDominio(false);
    }
  }, [myRoles]);

  return (
    <>
      <Button
        variant="contained"
        color="primary"
        onClick={handleClick}
        sx={{
          backgroundColor: "#336B87",
          color: "white",
          borderRadius: "20px", // Más redondeado
          textTransform: "none",
        }}
      >
        Acciones
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: { mt: "6px" }, // Baja el menú 6px
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => handleOption("Desanexar")}
          disabled={!myOrgs.length}
        >
          Desanexar de organización
        </MenuItem>

        <MenuItem
          onClick={() => handleOption("Anexar")}
        >
          Anexar a organización
        </MenuItem>

        <MenuItem
          onClick={() => handleOption("Asignar")}
          disabled={isAdminDominio}
        >
          Asignar Admin de Dominio
        </MenuItem>

        <MenuItem
          onClick={() => handleOption("Desasignar")}
          disabled={!isAdminDominio}
        >
          Desasignar Admin de Dominio
        </MenuItem>
      </Menu>

      {/* Modal para desanexar usuario */}
      <DetachModal isOpen={isDetachOpen} setIsOpen={setIsDetachOpen} />

      {/* Modal para anexar usuario */}
      <AttachModal isOpen={isAttachOpen} setIsOpen={setIsAttachOpen} />

      {/* Modal para asignar usuario a Admin de Dominio */}
      <AssignAdminModal isOpen={isAssignOpen} setIsOpen={setIsAssignOpen} />

      {/* Modal para desasignar usuario a Admin de Dominio */}
      <UnassignAdminModal isOpen={isUnassignOpen} setIsOpen={setIsUnassignOpen} />
    </>
  );
};

export default AccountActions;
